import {
    Drawer,
    Button,
    CircularProgress,
    IconButton,
    useMediaQuery
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { HighlightOff } from '@mui/icons-material';
import EventFilter from './EventFilter';
import { H4 } from '../../themes/typography';
import "../../styles/event/FilterDrawer.css"

export default function FilterDrawer({
    disabled = false,
    loading = false,
    eventFilterConfig = [],
    filterState = {},
    setFilterState = () => {},
    openFilter = false,
    handleCloseFilter = () => {},
    clearAllFilter = () => {},
    applyFilter = () => {}
}) {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Drawer
            anchor={isMobile ? "bottom" : "left"}
            open={openFilter}
            // onClose={handleCloseFilter}
            sx={{
                ...styles.drawerPaper,
                ...(isMobile && styles.mobileDrawerPaper)
            }}
        >
            <div id="event-filter-main-container">
                <div className='event-filter-wrapper'>
                    <div className="event-filter-title-and-close">
                        <H4 fontWeight={600}>
                            Filter Events
                        </H4>

                        <IconButton onClick={handleCloseFilter}>
                            <HighlightOff sx={{ fontSize: '1.75rem' }} />
                        </IconButton>
                    </div>

                    <EventFilter
                        filterState={filterState}
                        setFilterState={setFilterState}
                        eventFilterConfig={eventFilterConfig}
                    />

                    <div className="event-filter-apply-action">
                        <Button
                            variant="text"
                            fullWidth
                            onClick={clearAllFilter}
                        >
                            Clear All
                        </Button>
                        <Button
                            variant="main"
                            fullWidth
                            disabled={disabled || loading}
                            onClick={applyFilter}
                        >
                            Apply Filters
                            {loading && <CircularProgress size={20} sx={styles.circularProgress} />}
                        </Button>
                    </div>
                </div>
            </div>
        </Drawer>
    );
}

// const styles = {
//     accordionSummary: {
//         minHeight: '64px',
//         display: 'flex',
//         alignItems: 'center',
//         '& .MuiAccordionSummary-content': {
//             gap: '0.75rem'
//         }
//     },
//     accordionDetails: {
//         display: 'flex',
//         flexWrap: 'wrap',
//         gap: '0.75rem'
//     },
//     accordion: {
//         width: '100%',
//         background: 'transparent',
//         boxShadow: 'none',
//         borderRadius: '0px',
//         borderBottom: '1px solid var(--divider-color)',
//         '&:first-of-type': {
//             borderBottomLeftRadius: '0px',
//             borderBottomRightRadius: '0px',
//         },
//         '&:last-of-type': {
//             borderBottomLeftRadius: '0px',
//             borderBottomRightRadius: '0px',
//         }
//     },
//     drawerPaper: {
//         '& .MuiDrawer-paper': {
//             height: '100vh',
//             top: '0',
//             right: '0',
//             bottom: '0',
//             borderRadius: '0rem',
//             background: 'var(--primary-color)',
//         }
//     },
//     circularProgress: {
//         marginLeft: '0.75rem',
//         color: 'var(--primary-color)'
//     }
// };

const styles = {
    accordionSummary: {
        minHeight: '64px',
        display: 'flex',
        alignItems: 'center',
        '& .MuiAccordionSummary-content': {
            gap: '0.75rem'
        }
    },
    accordionDetails: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '0.75rem'
    },
    accordion: {
        width: '100%',
        background: 'transparent',
        boxShadow: 'none',
        borderRadius: '0px',
        borderBottom: '1px solid var(--divider-color)',
        '&:first-of-type': {
            borderBottomLeftRadius: '0px',
            borderBottomRightRadius: '0px',
        },
        '&:last-of-type': {
            borderBottomLeftRadius: '0px',
            borderBottomRightRadius: '0px',
        }
    },
    drawerPaper: {
        '& .MuiDrawer-paper': {
            height: '100vh',
            top: '0',
            right: '0',
            bottom: '0',
            borderRadius: '0rem',
            background: 'var(--primary-color)',
        }
    },
    mobileDrawerPaper: {
        '& .MuiDrawer-paper': {
            width: '100%',
            height: '100vh', // mobile height
            borderTopLeftRadius: '1rem',
            borderTopRightRadius: '1rem',
            background: 'var(--primary-color)',
        }
    },
    circularProgress: {
        marginLeft: '0.75rem',
        color: 'var(--primary-color)'
    }
};